/** Error thrown for all invalid crypto inputs / failed authenticated operations. */
export class FumeCryptoError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FumeCryptoError';
    }
}
//# sourceMappingURL=errors.js.map